import React , {useState, useEffect} from 'react';
import Headline5 from "../../components/headings/Headline5";
import FromHead from "../../components/headings/FromHead";
import Button from '../../components/button';
import Styles from "../basicDetails/styles.module.scss";
import ellowLogo from "../../assets/images/ellow-logo.png";
import { Typography } from "@progress/kendo-react-common"; 
import { postAPI } from '../../api/apis';
import { useLocation } from 'react-router-dom';
import NotificationAlert from '../../components/notification'
import  mixpanelData, { viewedpageMixpanel } from '../../utils/mixpanel';
import { REACT_APP_VERIFY } from '../../utils/common';


function NonVerifiedDashboard() {
  
  const location = useLocation();
  const Email = localStorage.getItem('Email')
  const candidateId: string = localStorage.getItem('candidateid') || ''
  const profileMetadata = JSON.parse(localStorage.getItem("profile_metadata") || "") || {}

  const [alert, setAlert] = useState<boolean>(false)

  useEffect(() => {
    viewedpageMixpanel()
  }, [])  

  
  const resendLink = () => { 
    let value :any = {
        email: Email ,
        candidateId: candidateId,
        candidateName : profileMetadata.firstName +' '+profileMetadata.lastName
    }
    postAPI( REACT_APP_VERIFY + '/resendemail', value).then((response) => {
        if(response){
            setAlert(true)
            setTimeout(() => {
            setAlert(false) 
            }, 4000);
          }
      })
      mixpanelData('MWP-Resend verification link', Email)
  }

  const alertOnclose = () => {
    setAlert(false);
  }
  
  return (
    
    <section className={Styles.profileWrapper}>
      {alert && <NotificationAlert closable={true}  onClose={alertOnclose}> We have resent a verification link to your mail id. Please Check</NotificationAlert> }
      <div className={Styles.header}>
        <img src={ellowLogo} alt="ellow.io" />
      </div>
      <div className="container">
        <div className={Styles.verification}>
        <Headline5>You are just one click away from unblocking the plethora of opportunities awaiting for your skillset.  </Headline5>
        <p className="mb-40">We have sent a verification link to <span>{Email}</span> to finish setting up the account.
       In case you couldn’t find the mail, Please check your spam/junk folder.</p>
          <Button variant="primary" onClick={resendLink}>Resend Link</Button>
        </div>
      </div>
    </section>
  )
}

export default NonVerifiedDashboard